export default __webpack_public_path__ + "static/media/natal.df137f4b.png";